import { RemoteDataPage } from '@lycoris-nubila/ngx-lycoris';
import { Observable } from 'rxjs';

import { MessageOutput } from 'infrastructure/graphql/messaging/message/model/message.output';

import { SendMessageCmd } from '../command/send-message.cmd';
import { ObserveMessagesQuery } from '../query/observe-messages.query';

export abstract class MessageApiPort {
	public abstract fetchMessageById(id: string): Promise<MessageOutput>;

	public abstract fetchMessages(
		query: ObserveMessagesQuery
	): Observable<MessageOutput[]>;

	public abstract sendMessage(cmd: SendMessageCmd): Promise<MessageOutput>;

	public abstract markMessagesRead(
		messagesId: string[]
	): Promise<MessageOutput[]>;
}
